export default "__VITE_ASSET__KWjKqYVr__"